import { createNgReactBridgeDirective } from '../../react-bridge'
import { VulnerabilityTtrManager } from '../../../components/vulnerability-management'

export const reactVulnerabilityTtrManager = createNgReactBridgeDirective(
  'reactVulnerabilityTtrManager',
  [],
  VulnerabilityTtrManager,
  []
)
